export interface ConnectedVehicleType {
  name: string
  id: string
}

export interface RemovedVehicleType {
  name: string
  id: number
  date: number
}

export interface DailyEnergyConsumption {
  date: string
  gridEnergy: number
  pvEnergy: number
}

export enum VehicleModel {
  Tesla3 = 'TESLA_3',
  TeslaY = 'TESLA_Y',
}

export interface Vehicle {
  name: string
  model: VehicleModel
  state: VehicleConnectionStatus
  chargingValue: number
  id: string
}

export enum VehicleConnectionStatus {
  Disconnected = 'disconnected',
  Connected = 'connected',
  Charging = 'charging',
}

export enum VehicleChargingState {
  plugged = 'PLUGGED',
  unplugged = 'UNPLUGGED',
  charging = 'CHARGING',
  preparing = 'PREPARING',
  finished = 'FINISHED',
  stopped = 'STOPPED',
  fault = 'FAULT',
}

export enum ManufacturerState {
  available = 'AVAILABLE',
  unchecked = 'UNCHECKED',
  temporarilyUnavailable = 'TEMP_UNAVAILABLE',
  unavailable = 'UNAVAILABLE',
}

export type ChargingStateType = `${VehicleChargingState}`

export enum TypeOfDeletion {
  installation = 'installation',
  all = 'all',
}
